import React, { Fragment } from 'react';
import Styled from './styles';
import { Button, TextField, Select, Switch, Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, MenuItem } from 'material-ui';
import api from '../../../lib/api';
import LinkGenerated from '../LinkGenerated';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0
  },
  textField: {
    marginRight: theme.spacing.unit,
    width: 276,
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    padding: '10px'
  },
  input: {
    fontSize: 16,
    fontWeight: 'normal',
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  }
});
class GeneratePaymentLink extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.initialState = {
      companyId: '',
      companyName: '',
      userPhone: '',
      userEmail: '',
      validTill: '',
      validTime: '',
      expiryTime: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pan: '',
      gstn: '',
      contactName: '',
      customerEmailId: '',
      salesType: '',
      prorationNeeded: false,
      salesRepEmails: [],
      salesPersonPrimaryEmail: 'Select Primary Email',
      salesPersonSecondaryEmail: 'Select Secondary Email',
      errorMessage: '',
      planType: 'GROWTH',
      originalAmount: '',
      duration: '',
      activationDate: '',
      activationTime: '',
      offerMessage: '',
      discountType: 'Discount %',
      discountPercent: '',
      discountAmount: '',
      completeActivationTime: '',
      finalDiscountPercentage: '',
      finalAmount: '',
      refundDays: '',
      planExpiryTime: '',
      strikedAmount: '',
      isNativeAppPayment: false,
      isIOSNativeApp: false,
      isAndroidNativeApp: false,
      isResellerChannels: false,
      isResellerApp: false,
      isPrivacyModule: false,
      isWhitelabel: false,
      isAmazonVoucherOf2k: false,
      isAdditionalMonths: false,
      isThirdPartyIntegrations: false,
      isDoubleTick: false,
      doubleTickLoginNumber: '',
      doubleTickTeamMembers: '',
      doubleTickAmountPaid: '',
      doubleTickOrgName: '',
      doubleTickOwnerName: '',
      doubleTickOrgId: '',
      errorCompanyID: false,
      errorDuration: false,
      errorAddress: false,
      errorCity: false,
      errorState: false,
      errorCountry: false,
      errorPan: false,
      errorGstn: false,
      errorContactName: false,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false,
      errorCustomerEmailId: false,
      errorValidTill: false,
      errorValidTime: false,
      errorPlanAmount: false,
      errorRefundDays: false,
      errorDiscountPercent: false,
      errorDiscountAmount: false,
      errorActivationDate: false,
      errorActivationTime: false,
      errorDoubleTickLoginNumber: false,
      errorDoubleTickTeamMembers: false,
      errorMessageDoubleTickLoginNumber: '',
      errorMessageDoubleTickTeamMembers: '',
      errorMessageDoubleTickAmountPaid: '',
      errorMessageDoubleTickOrgName: '',
      errorMessageDoubleTickOwnerName: '',
      errorMessageDoubleTickOrgId: '',
      disableTextField: true,
      disableDiscountField: true,
      disablePlanTypeActivationTime: false
    };

    this.state = { ...this.initialState };
  }

  componentDidMount() {
    api
      .getSalesPersonEmail()
      .then(({ salesRepEmails }) => {
        this.setState({ salesRepEmails });
      })
      .catch(reason => console.log(reason));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.companyId && this.state.companyId !== prevState.companyId) {
      api
        .getSalesType(this.state.companyId)
        .then(({ salesType, prorationNeeded }) => {
          this.setState({ salesType, prorationNeeded });
        })
        .catch(reason => console.log(reason));
    }

    if (
      this.state.discountAmount !== prevState.discountAmount ||
      this.state.discountPercent !== prevState.discountPercent ||
      this.state.originalAmount !== prevState.originalAmount ||
      this.state.doubleTickAmountPaid !== prevState.doubleTickAmountPaid ||
      this.state.isDoubleTick !== prevState.isDoubleTick
    ) {
      const finalAmount = this.calcFinalAmount(
        this.state.discountPercent,
        this.state.discountAmount,
        this.state.originalAmount,
        this.state.doubleTickAmountPaid,
        this.state.isDoubleTick
      );

      this.setState({
        finalAmount
      });
    }

    if (
      this.state.originalAmount !== prevState.originalAmount ||
      this.state.doubleTickAmountPaid !== prevState.doubleTickAmountPaid ||
      this.state.isDoubleTick !== prevState.isDoubleTick
    ) {
      const strikedAmount =
        (this.state.originalAmount ? +this.state.originalAmount : 0) +
        (this.state.doubleTickAmountPaid && this.state.isDoubleTick
          ? +this.state.doubleTickAmountPaid
          : 0);

      this.setState({
        strikedAmount
      });
    }
  }

  companyIdChange = e => {
    if (!e.target.value) {
      this.setState({
        companyName: '',
        userPhone: '',
        userEmail: '',
        planExpiryTime: ''
      });
    }
    this.setState({ companyId: e.target.value, errorCompanyID: false });
  };

  getCompanyDetails = async e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.value) {
      try {
        this.setState({ loading: true, disableTextField: true });
        const {
          target: { value }
        } = e;
        let companyId = value;
        let {
          companyName,
          userPhone,
          userEmail,
          expiryTime: planExpiryTime
        } = await api.getCompanyIdDetails(companyId);

        const validActivationTimeCheck = moment(planExpiryTime).isAfter(
          moment()
        );

        const completeActivationTime = validActivationTimeCheck
          ? moment(planExpiryTime).toISOString()
          : '';

        const activationDate = validActivationTimeCheck
          ? moment(planExpiryTime).format('YYYY-MM-DD')
          : '';

        const activationTime = validActivationTimeCheck
          ? moment(planExpiryTime).format('HH:mm')
          : '';

        this.setState({
          companyName: companyName,
          userPhone: userPhone,
          userEmail: userEmail,
          loading: false,
          disableTextField: false,
          planExpiryTime,
          completeActivationTime,
          activationTime,
          activationDate
        });
      } catch (error) {
        console.log(error.response.statusText);

        this.setState({
          companyName: '',
          userPhone: '',
          userEmail: '',
          loading: false,
          disableTextField: true,
          errorCompanyID: true,
          planExpiryTime: '',
          activationDate: '',
          activationTime: '',
          completeActivationTime: ''
        });
      }
    }
  };

  getDoubleTickOrganizationDetails = async e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.value) {
      try {
        this.setState({ loading: true });
        const {
          orgId,
          orgName,
          ownerName
        } = await api.getDoubleTickOrganizationDetails(
          this.state.doubleTickLoginNumber
        );

        this.setState({
          doubleTickOrgId: orgId,
          doubleTickOrgName: orgName,
          doubleTickOwnerName: ownerName,
          loading: false,
          errorMessageDoubleTickOrgId: '',
          errorMessageDoubleTickOrgName: '',
          errorMessageDoubleTickOwnerName: ''
        });
      } catch (error) {
        this.setState({
          loading: false,
          doubleTickOrgId: '',
          doubleTickOrgName: '',
          doubleTickOwnerName: '',
          errorMessageDoubleTickOrgId: 'Organization Id not found',
          errorMessageDoubleTickOrgName: 'Organization Name not found',
          errorMessageDoubleTickOwnerName: 'Owner Name not found'
        });
      }
    }
  };

  onNativePaymentCheck = e => {
    const newValue = !this.state.isNativeAppPayment;

    const additionalStateUpdates = {};

    if (this.state.prorationNeeded && newValue) {
      additionalStateUpdates.disableTextField = false;
    } else if (this.state.prorationNeeded && !newValue) {
      additionalStateUpdates.disableTextField = true;
    }

    this.setState({
      isNativeAppPayment: newValue,
      disablePlanTypeActivationTime: !this.state.disablePlanTypeActivationTime,
      ...additionalStateUpdates
    });
  };
  onIOSNativeAppChange = e => {
    this.setState({
      isIOSNativeApp: !this.state.isIOSNativeApp
    });
  };
  onAndroidNativeAppChange = e => {
    this.setState({
      isAndroidNativeApp: !this.state.isAndroidNativeApp
    });
  };
  onResellerChannelsChange = e => {
    this.setState({
      isResellerChannels: !this.state.isResellerChannels
    });
  };
  onResellerAppChange = e => {
    this.setState({
      isResellerApp: !this.state.isResellerApp
    });
  };
  onPrivacyModuleChange = e => {
    this.setState({
      isPrivacyModule: !this.state.isPrivacyModule
    });
  };
  onWhitelabelChange = e => {
    this.setState({
      isWhitelabel: !this.state.isWhitelabel
    });
  };
  onAmazonVoucherOf2kChange = e => {
    this.setState({
      isAmazonVoucherOf2k: !this.state.isAmazonVoucherOf2k
    });
  };
  onAdditionalMonthsChange = e => {
    this.setState({
      isAdditionalMonths: !this.state.isAdditionalMonths
    });
  };
  onThirdPartyIntegrationsChange = e => {
    this.setState({
      isThirdPartyIntegrations: !this.state.isThirdPartyIntegrations
    });
  };

  onDoubletickChange = () => {
    this.setState({
      isDoubleTick: !this.state.isDoubleTick
    });
  };

  onDoubleTickLoginNumberChange = e => {
    if (e.target.value.length > 10) {
      return;
    }
    this.setState({
      doubleTickLoginNumber: e.target.value,
      errorMessageDoubleTickOrgId: ''
    });
  };

  onDoubleTickTeamMembersChange = e => {
    this.setState({
      doubleTickTeamMembers: +e.target.value,
      errorMessageDoubleTickOrgId: ''
    });
  };

  onDoubleTickAmountChange = e => {
    this.setState({
      doubleTickAmountPaid: +e.target.value,
      errorMessageDoubleTickOrgId: ''
    });
  };

  onAddressChange = event => {
    const { value } = event.target;
    this.setState({ address: value, errorAddress: false });
  };
  onStateChange = event => {
    const { value } = event.target;
    this.setState({ state: value, errorState: false });
  };
  onCityChange = event => {
    const { value } = event.target;
    this.setState({ city: value, errorCity: false });
  };
  onCountryChange = event => {
    const { value } = event.target;
    this.setState({ country: value, errorCountry: false });
  };

  onPanChange = event => {
    const { value } = event.target;
    this.setState({ pan: value, errorPan: false });
  };
  onGstnChange = event => {
    const { value } = event.target;
    this.setState({ gstn: value, errorGstn: false });
  };
  onContactNameChange = event => {
    const { value } = event.target;
    this.setState({ contactName: value, errorContactName: false });
  };
  onCustomerEmailIdChange = event => {
    const { value } = event.target;
    this.setState({ customerEmailId: value, errorCustomerEmailId: false });
  };
  onSalesPersonPrimaryEmailChange = event => {
    event.preventDefault();
    event.stopPropagation();
    const { value } = event.target;
    if (value === this.state.salesPersonSecondaryEmail) {
      return this.setState({ errorSalesPersonalPrimaryEmail: true });
    }
    this.setState({
      salesPersonPrimaryEmail: value,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false
    });
  };
  onSalesPersonSecondaryEmailChange = event => {
    event.preventDefault();
    event.stopPropagation();
    const { value } = event.target;

    if (this.state.salesPersonPrimaryEmail === value) {
      return this.setState({ errorSalesPersonalSecondaryEmail: true });
    }
    this.setState({
      salesPersonSecondaryEmail: value,
      errorSalesPersonalPrimaryEmail: false,
      errorSalesPersonalSecondaryEmail: false
    });
  };
  changeCompleteActivationTime = (date, time) => {
    if (date && time) {
      const completeActivationTime = moment(
        `${moment(date).format('YYYY-MM-DD')}_${time}`,
        'YYYY-MM-DD_HH:mm'
      )
        .toDate()
        .toISOString();
      this.setState({ completeActivationTime: completeActivationTime });
    }
  };
  onActivationDateChange = event => {
    const { value } = event.target;
    if (moment(this.state.planExpiryTime).isAfter(moment(value))) {
      this.setState({ errorActivationDate: true, activationDate: '' });
      return;
    }
    this.setState({ activationDate: value, errorActivationDate: false });
    this.changeCompleteActivationTime(value, this.state.activationTime);
  };
  onDateChange = event => {
    const { value } = event.target;
    this.setState({ validTill: value });
    const minDate = moment()
      .startOf('day')
      .valueOf();
    const selectedDate = moment(value)
      .startOf('day')
      .valueOf();
    if (minDate > selectedDate) {
      this.setState({ errorValidTill: true });
      return;
    }
    this.calcExpiryTime(value, this.state.validTime);
    this.setState({ errorValidTill: false, validTill: value });
  };
  onTimeChange = e => {
    const { value } = e.target;
    this.setState({ validTime: value, errorValidTime: false });
    this.calcExpiryTime(this.state.validTill, value);
  };
  onActivationTimeChange = e => {
    const { value } = e.target;
    if (
      this.state.activationDate &&
      moment(
        `${moment(this.state.activationDate).format('YYYY-MM-DD')}_${value}`,
        'YYYY-MM-DD_HH:mm'
      ).isBefore(moment(this.state.planExpiryTime))
    ) {
      this.setState({ errorActivationTime: true, activationTime: '' });
      return;
    }
    this.setState({ activationTime: value, errorActivationTime: false });
    this.changeCompleteActivationTime(this.state.activationDate, value);
  };
  calcExpiryTime = (date, time) => {
    if (date && time) {
      const expiryTime = moment(`${date}_${time}`, 'YYYY-MM-DD_HH:mm')
        .toDate()
        .toISOString();
      this.setState({ expiryTime: expiryTime });
    }
  };
  onKeyPress = e => {
    //to remove +,-,e when type = "number"
    if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
      e.preventDefault();
    }
  };
  onDurationChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({
      duration: value,
      errorDuration: this.state.isNativeAppPayment && value % 12 !== 0
    });
  };
  offerMessage = e => {
    const {
      target: { value }
    } = e;
    this.setState({ offerMessage: value });
  };

  planAmountChange = e => {
    const {
      target: { value }
    } = e;
    this.setState({
      originalAmount: value,
      errorPlanAmount: false,
      disableDiscountField: false
    });
    if (!value) {
      this.setState({
        finalAmount: '',
        finalDiscountPercentage: '',
        discountAmount: '',
        discountPercent: '',
        disableDiscountField: true
      });
      return;
    }
    this.calcFinalDiscountPercentage(
      this.state.discountPercent,
      this.state.discountAmount,
      value
    );
  };
  onChangeType = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({ planType: value });
  };

  onDiscountTypeChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({
      discountType: value,
      finalDiscountPercentage: '',
      finalAmount: '',
      discountPercent: '',
      discountAmount: '',
      errorDiscountAmount: false,
      errorDiscountPercent: false
    });
  };
  calcFinalDiscountPercentage = (
    discountPercent,
    discountAmount,
    originalPlanAmount
  ) => {
    if (discountPercent || discountAmount) {
      if (discountPercent && parseInt(originalPlanAmount)) {
        this.setState({ finalDiscountPercentage: discountPercent });
      } else if (parseInt(originalPlanAmount)) {
        discountAmount = Number(discountAmount);
        originalPlanAmount = Number(originalPlanAmount);
        discountPercent = Math.round(
          (discountAmount / originalPlanAmount) * 100
        );
        if (isNaN(discountPercent)) {
          this.setState({ finalDiscountPercentage: '' });
          return;
        }
        this.setState({ finalDiscountPercentage: discountPercent });
      }
    } else {
      this.setState({ finalDiscountPercentage: '' });
    }
  };

  calcFinalAmount = (
    discountPercent,
    discountAmount,
    originalPlanAmount,
    doubleTickAmount,
    isDoubleTick
  ) => {
    if (Number.isNaN(+originalPlanAmount)) {
      return '';
    }

    if (discountPercent) {
      discountPercent = Number(discountPercent);
      originalPlanAmount = Number(originalPlanAmount);
      discountAmount = Math.round((discountPercent / 100) * originalPlanAmount);
      if (isNaN(discountAmount)) {
        return '';
      }
    } else if (discountPercent) {
      discountAmount = Number(discountAmount);
      originalPlanAmount = Number(originalPlanAmount);
      discountPercent = Math.round((discountAmount / originalPlanAmount) * 100);
      if (isNaN(discountPercent)) {
        return '';
      }
    }

    return (
      originalPlanAmount -
      (discountAmount || 0) +
      (!Number.isNaN(+doubleTickAmount) && isDoubleTick ? doubleTickAmount : 0)
    );
  };

  onDiscountPercentChange = e => {
    const {
      target: { value }
    } = e;
    this.calcFinalDiscountPercentage(value, '', this.state.strikedAmount);
    this.setState({ discountPercent: value, errorDiscountPercent: false });
  };

  onDiscountAmountChange = e => {
    const {
      target: { value }
    } = e;
    this.calcFinalDiscountPercentage('', value, this.state.strikedAmount);
    this.setState({ discountAmount: value, errorDiscountAmount: false });
  };

  onRefundDaysChange = e => {
    const {
      target: { value }
    } = e;

    this.setState({ refundDays: value, errorRefundDays: false });
  };
  validateForm = () => {
    let errorFlag = false;
    if (!this.state.companyId || this.state.errorCompanyID) {
      errorFlag = true;
      this.setState({ errorCompanyID: true });
    }
    if (
      this.state.isNativeAppPayment &&
      (!this.state.duration || Number(this.state.duration) % 12 !== 0)
    ) {
      errorFlag = true;
      this.setState({ errorDuration: true, duration: '' });
    }
    if (
      !this.state.isNativeAppPayment &&
      (!this.state.duration || Number(this.state.duration) > 120)
    ) {
      errorFlag = true;
      this.setState({ errorDuration: true, duration: '' });
    }
    if (
      !this.state.strikedAmount ||
      Number(this.state.strikedAmount) > 2000000 ||
      Number(this.state.strikedAmount) < 1
    ) {
      errorFlag = true;
      this.setState({
        errorPlanAmount: true,
        originalAmount: '',
        strikedAmount: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      (!this.state.discountPercent &&
        this.state.discountType === 'Discount %') ||
      parseInt(this.state.discountPercent) < 1 ||
      parseInt(this.state.discountPercent) > 100
    ) {
      errorFlag = true;
      this.setState({
        errorDiscountPercent: true,
        discountPercent: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      (!this.state.discountAmount &&
        this.state.discountType === 'Discount Amount') ||
      Number(this.state.discountAmount) < 0 ||
      Number(this.state.discountAmount) > Number(this.state.strikedAmount)
    ) {
      errorFlag = true;
      this.setState({
        errorDiscountAmount: true,
        discountAmount: '',
        finalDiscountPercentage: '',
        finalAmount: ''
      });
    }
    if (
      this.state.refundDays &&
      (this.state.refundDays < 1 || this.state.refundDays > 14)
    ) {
      errorFlag = true;
      this.setState({ errorRefundDays: true });
    }
    if (!this.state.validTill) {
      errorFlag = true;
      this.setState({ errorValidTill: true });
    }
    if (!this.state.validTime) {
      errorFlag = true;
      this.setState({ errorValidTime: true });
    }
    // if (!this.state.address) {
    //   errorFlag = true;
    //   this.setState({ errorAddress: true });
    // }
    // if (!this.state.city) {
    //   errorFlag = true;
    //   this.setState({ errorCity: true });
    // }
    // if (!this.state.state) {
    //   errorFlag = true;
    //   this.setState({ errorState: true });
    // }
    // if (!this.state.country) {
    //   errorFlag = true;
    //   this.setState({ errorCountry: true });
    // }
    // if (!this.state.contactName) {
    //   errorFlag = true;
    //   this.setState({ errorContactName: true });
    // }
    // if (!this.state.customerEmailId) {
    //   errorFlag = true;
    //   this.setState({ errorCustomerEmailId: true });
    // }
    if (this.state.salesPersonPrimaryEmail === 'Select Primary Email') {
      errorFlag = true;
      this.setState({ errorSalesPersonalPrimaryEmail: true });
    }
    if (this.state.prorationNeeded && !this.state.isNativeAppPayment) {
      errorFlag = true;
    }

    if (this.state.isDoubleTick && !this.state.doubleTickLoginNumber) {
      errorFlag = true;
      this.setState({ errorDoubleTickLoginNumber: true });
    }

    if (this.state.isDoubleTick && !this.state.doubleTickTeamMembers) {
      errorFlag = true;
      this.setState({ errorDoubleTickTeamMembers: true });
    }

    if (this.state.isDoubleTick && !this.state.doubleTickAmountPaid) {
      errorFlag = true;
      this.setState({
        errorMessageDoubleTickAmountPaid: 'Amount Paid is required'
      });
    }

    if (this.state.isDoubleTick && !this.state.doubleTickOrgId) {
      errorFlag = true;
      this.setState({
        errorMessageDoubleTickOrgId: 'Invalid Organization ID'
      });
    }

    if (this.state.isDoubleTick && !this.state.doubleTickOrgName) {
      errorFlag = true;
      this.setState({
        errorMessageDoubleTickOrgName: 'Invalid Organization Name'
      });
    }

    if (this.state.isDoubleTick && !this.state.doubleTickOwnerName) {
      errorFlag = true;
      this.setState({ errorMessageDoubleTickOwnerName: 'Invalid Owner Name' });
    }

    if (
      typeof this.state.doubleTickAmountPaid !== 'undefined' &&
      this.state.doubleTickAmountPaid !== '' &&
      this.state.doubleTickAmountPaid !== null
    ) {
      if (this.state.doubleTickAmountPaid > this.state.strikedAmount) {
        errorFlag = true;
        this.setState({
          errorMessageDoubleTickAmountPaid:
            'Amount Paid should be less than or equal to Plan Amount'
        });
      }
    }

    return errorFlag;
  };

  onGenerateLink = async () => {
    this.setState({
      errorGeneratedLink: false
    });
    let errorFlag = this.validateForm();
    if (errorFlag) {
      return;
    }
    const sendGstnOrPan = () => {
      if (this.state.pan) {
        return { pan: this.state.pan };
      }
      if (this.state.gstn) {
        return { gst: this.state.gstn };
      }
    };

    const formData = {
      companyId: this.state.companyId,
      expiryTime: this.state.expiryTime,
      planExpiryTime: this.state.planExpiryTime,
      offerMessage: this.state.offerMessage,
      planType: this.state.planType,
      originalAmount: +this.state.strikedAmount,
      activationTime: this.state.completeActivationTime
        ? this.state.completeActivationTime
        : null,
      duration: +this.state.duration,
      streetAddress: this.state.address,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      ...sendGstnOrPan(),
      contactPersonName: this.state.contactName,
      customerEmailId: this.state.customerEmailId,
      salesType: this.state.salesType,
      prorationNeeded: this.state.prorationNeeded,
      salesRepPrimaryEmail: this.state.salesPersonPrimaryEmail,
      salesRepSecondaryEmail:
        this.state.salesPersonSecondaryEmail === 'Select Secondary Email'
          ? ''
          : this.state.salesPersonSecondaryEmail,
      refundDays: this.state.refundDays ? +this.state.refundDays : null,
      discountType:
        this.state.discountType === 'Discount %' ? 'PERCENT' : 'ABSOLUTE',
      discountAmount:
        this.state.discountType === 'Discount %'
          ? +this.state.discountPercent
          : +this.state.discountAmount,
      isNativeAppPayment: this.state.isNativeAppPayment,
      additionalModules: {
        iOSNativeApp: this.state.isIOSNativeApp,
        androidNativeApp: this.state.isAndroidNativeApp,
        resellerChannels: this.state.isResellerChannels,
        resellerApp: this.state.isResellerApp,
        privacyModule: this.state.isPrivacyModule,
        whitelabel: this.state.isWhitelabel,
        amazonVoucherOf2k: this.state.isAmazonVoucherOf2k,
        additionalMonths: this.state.isAdditionalMonths,
        thirdPartyIntegrations: this.state.isThirdPartyIntegrations,
        doubleTick: this.state.isDoubleTick
          ? {
              orgId: this.state.doubleTickOrgId,
              teamMembers: +this.state.doubleTickTeamMembers,
              amountPaid: +this.state.doubleTickAmountPaid
            }
          : null
      }
    };

    try {
      const { salesLink } = await api.generateLink(formData);
      this.setState({
        salesLink: salesLink,
        showLinkGenerated: !this.state.showLinkGenerated,
        errorGeneratedLink: false
      });
      this.cleanState();
    } catch (error) {
      console.log(error.response.statusText);
      this.setState({
        errorGeneratedLink: true,
        errorMessage: error.response.data.message
      });
    }
  };

  cleanState = () => {
    this.setState(this.initialState);
  };

  onToggle = () => {
    this.setState({
      showLinkGenerated: !this.state.showLinkGenerated
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.showLinkGenerated ? (
          <LinkGenerated
            onToggle={this.onToggle}
            salesLink={this.state.salesLink}
            mode="payment"
          />
        ) : (
          <Styled.GeneratePaymentLinkContainer>
            <Styled.Title>Payment link generator</Styled.Title>
            <FormControl>
              <Styled.LabelAndTextField>
                <Styled.Label>Company Id</Styled.Label>
                <Styled.InputField>
                  <TextField
                    id="CompanyID"
                    type="text"
                    inputMode={'numeric'}
                    autoComplete="off"
                    className={classes.textField}
                    onBlur={
                      !this.state.prorationNeeded ||
                      this.state.isNativeAppPayment
                        ? this.getCompanyDetails
                        : null
                    }
                    onChange={this.companyIdChange}
                    value={this.state.companyId}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorCompanyID && (
                    <Styled.Error>Invalid CompanyId</Styled.Error>
                  )}
                  {this.state.prorationNeeded &&
                    !this.state.isNativeAppPayment && (
                      <Styled.Error>
                        Use &ldquo;Create upgrade payment link&rdquo; option for
                        this company
                      </Styled.Error>
                    )}
                </Styled.InputField>
                {this.state.loading && (
                  <Styled.LoaderContainer>
                    <CircularProgress size={20} thickness={5} color="primary" />
                  </Styled.LoaderContainer>
                )}
              </Styled.LabelAndTextField>
              <Styled.VerifyDetailsContainer>
                Please verify details:
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Company Name</Styled.DetailTitle>
                  <Styled.Label>{this.state.companyName}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Phone</Styled.DetailTitle>
                  <Styled.Label>{this.state.userPhone}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Email</Styled.DetailTitle>
                  <Styled.Label>{this.state.userEmail}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Sales Type</Styled.DetailTitle>
                  {this.state.userEmail && (
                    <Styled.Label>{this.state.salesType}</Styled.Label>
                  )}
                </Styled.DetailContainer>
              </Styled.VerifyDetailsContainer>
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>Full Address</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="address"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onAddressChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.address}*/}
              {/*    />*/}
              {/*    {this.state.errorAddress && (*/}
              {/*      <Styled.Error>Address is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>City</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="city"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onCityChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.city}*/}
              {/*    />*/}
              {/*    {this.state.errorCity && (*/}
              {/*      <Styled.Error>City is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>State</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="state"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onStateChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.state}*/}
              {/*    />*/}
              {/*    {this.state.errorState && (*/}
              {/*      <Styled.Error>State is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>Country</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="country"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onCountryChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.country}*/}
              {/*    />*/}
              {/*    {this.state.errorCountry && (*/}
              {/*      <Styled.Error>Country is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              <Styled.LabelAndTextField>
                <Styled.Label>Native App Payment</Styled.Label>
                <Styled.InputField>
                  <Switch
                    checked={this.state.isNativeAppPayment}
                    onChange={this.onNativePaymentCheck}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                  />
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>PAN</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField || !!this.state.gstn}
                    id="pan"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    style={{
                      backgroundColor: this.state.gstn ? 'lightgray' : 'white'
                    }}
                    onChange={this.onPanChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.pan}
                  />
                  {!!this.state.gstn && (
                    <Styled.Error>
                      Disabled as only GSTN or PAN can be used at once{' '}
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>GSTN</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField || !!this.state.pan}
                    id="gstn"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    style={{
                      backgroundColor: this.state.pan ? 'lightgray' : 'white'
                    }}
                    onChange={this.onGstnChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.gstn}
                  />
                  {!!this.state.pan && (
                    <Styled.Error>
                      Disabled as only GSTN or PAN can be used at once{' '}
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>Contact Person Name</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="contactName"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onContactNameChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.contactName}*/}
              {/*    />*/}
              {/*    {this.state.errorContactName && (*/}
              {/*      <Styled.Error>Contact person name is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              {/*<Styled.LabelAndTextField>*/}
              {/*  <Styled.Label>Customer Email</Styled.Label>*/}
              {/*  <FormControl>*/}
              {/*    <TextField*/}
              {/*      disabled={this.state.disableTextField}*/}
              {/*      id="customerEmailId"*/}
              {/*      autoComplete="off"*/}
              {/*      type="text"*/}
              {/*      className={classes.textField}*/}
              {/*      onChange={this.onCustomerEmailIdChange}*/}
              {/*      InputLabelProps={{*/}
              {/*        shrink: true*/}
              {/*      }}*/}
              {/*      InputProps={{*/}
              {/*        disableUnderline: true,*/}
              {/*        classes: { input: classes.input }*/}
              {/*      }}*/}
              {/*      value={this.state.customerEmailId}*/}
              {/*    />*/}
              {/*    {this.state.errorCustomerEmailId && (*/}
              {/*      <Styled.Error>Customer email is empty</Styled.Error>*/}
              {/*    )}*/}
              {/*  </FormControl>*/}
              {/*</Styled.LabelAndTextField>*/}
              <Styled.LabelAndTextField>
                <Styled.Label>
                  Email of Sales Person <br /> (Primary)
                </Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    className={classes.textField}
                    value={this.state.salesPersonPrimaryEmail}
                    onChange={this.onSalesPersonPrimaryEmailChange}
                  >
                    <MenuItem value={'Select Primary Email'}>
                      Select Primary Email
                    </MenuItem>
                    {this.state.salesRepEmails.map(email => {
                      return (
                        <MenuItem key={email} value={email}>
                          {email}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {this.state.errorSalesPersonalPrimaryEmail && (
                    <Styled.Error>
                      Primary email can not be empty or same as secondary email
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>
                  Email of Sales Person <br /> (Secondary)
                </Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    className={classes.textField}
                    value={this.state.salesPersonSecondaryEmail}
                    onChange={this.onSalesPersonSecondaryEmailChange}
                  >
                    <MenuItem value={'Select Secondary Email'}>
                      Select Secondary Email
                    </MenuItem>
                    {this.state.salesRepEmails.map(email => {
                      return (
                        <MenuItem key={email} value={email}>
                          {email}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {this.state.errorSalesPersonalSecondaryEmail && (
                    <Styled.Error>
                      Secondary email can not be same as primary email
                    </Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Valid Date</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="date"
                    autoComplete="off"
                    type="date"
                    className={classes.textField}
                    onChange={this.onDateChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={
                      this.state.validTill
                        ? new Date(this.state.validTill)
                            .toISOString()
                            .slice(0, 10)
                        : ''
                    }
                  />
                  {this.state.errorValidTill && (
                    <Styled.Error>Invalid Date</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Valid Time</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="time"
                    autoComplete="off"
                    type="time"
                    value={this.state.validTime}
                    onChange={this.onTimeChange}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                  />
                  {this.state.errorValidTime && (
                    <Styled.Error>Time Field is empty</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Plan Type</Styled.Label>
                <FormControl>
                  <Select
                    disabled={
                      this.state.disableTextField ||
                      this.state.disablePlanTypeActivationTime
                    }
                    className={classes.textField}
                    value={this.state.planType}
                    onChange={this.onChangeType}
                  >
                    <MenuItem value="GROWTH">GROWTH</MenuItem>
                    <MenuItem value="PLATINUM">PLATINUM</MenuItem>
                    <MenuItem value="PREMIUM">PREMIUM</MenuItem>
                    <MenuItem value="UNLIMITED">UNLIMITED</MenuItem>
                  </Select>
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Activation Date</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={
                      this.state.disableTextField ||
                      this.state.disablePlanTypeActivationTime
                    }
                    id="date"
                    autoComplete="off"
                    type="date"
                    className={classes.textField}
                    onChange={this.onActivationDateChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={
                      this.state.activationDate
                        ? new Date(this.state.activationDate)
                            .toISOString()
                            .slice(0, 10)
                        : ''
                    }
                  />
                  {this.state.errorActivationDate && (
                    <Styled.Error>Invalid Date</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Activation Time</Styled.Label>
                <FormControl>
                  <TextField
                    disabled={
                      this.state.disableTextField ||
                      this.state.disablePlanTypeActivationTime
                    }
                    id="time"
                    autoComplete="off"
                    type="time"
                    value={this.state.activationTime}
                    onChange={this.onActivationTimeChange}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                  />
                  {this.state.errorActivationTime && (
                    <Styled.Error>Invalid Activation Time</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Duration (months)</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Duration"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.duration}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onDurationChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorDuration && (
                    <Styled.Error>Invalid Duration</Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>
                  <Styled.OfferMessageTitle>
                    Offer Message
                  </Styled.OfferMessageTitle>
                  <Styled.OfferMessageDescription>
                    Example : Special CEO Approval
                  </Styled.OfferMessageDescription>
                </Styled.Label>

                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    type="text"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.offerMessage}
                    onChange={this.offerMessage}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.VerifyDetailsContainer>
                <Styled.Label>Additional Modules</Styled.Label>
                <Styled.AdditionalModulesContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      iOS Native App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isIOSNativeApp}
                        onChange={this.onIOSNativeAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Android Native App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAndroidNativeApp}
                        onChange={this.onAndroidNativeAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Reseller Channels
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isResellerChannels}
                        onChange={this.onResellerChannelsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Reseller App
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isResellerApp}
                        onChange={this.onResellerAppChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Privacy Module
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isPrivacyModule}
                        onChange={this.onPrivacyModuleChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Whitelabel
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isWhitelabel}
                        onChange={this.onWhitelabelChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Amazon Voucher of 2k
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAmazonVoucherOf2k}
                        onChange={this.onAmazonVoucherOf2kChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Additional Months
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isAdditionalMonths}
                        onChange={this.onAdditionalMonthsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      3rd Party Integrations
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isThirdPartyIntegrations}
                        onChange={this.onThirdPartyIntegrationsChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                  <Styled.DetailContainer>
                    <Styled.AdditionalModule>
                      Doubletick
                    </Styled.AdditionalModule>
                    <Styled.InputField>
                      <Checkbox
                        checked={this.state.isDoubleTick}
                        onChange={this.onDoubletickChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                      />
                    </Styled.InputField>
                  </Styled.DetailContainer>
                </Styled.AdditionalModulesContainer>
              </Styled.VerifyDetailsContainer>

              {this.state.isDoubleTick && (
                <Fragment>
                  <Styled.LabelAndTextField>
                    <Styled.Label>Doubletick Login No.</Styled.Label>
                    <Styled.InputField>
                      <TextField
                        disabled={this.state.disableTextField}
                        id="doubletickLoginNumber"
                        autoComplete="off"
                        className={classes.textField}
                        onKeyPress={this.onKeyPress}
                        value={this.state.doubleTickLoginNumber}
                        onChange={this.onDoubleTickLoginNumberChange}
                        onBlur={
                          this.state.doubleTickLoginNumber.length === 10
                            ? this.getDoubleTickOrganizationDetails
                            : null
                        }
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                        margin="normal"
                      />
                      {this.state.errorDoubleTickLoginNumber && (
                        <Styled.Error>
                          Doubletick Login No. is required when Doubletick is
                          enabled
                          {this.state.errorMessageDoubleTickOrgId && (
                            <Styled.Error>
                              {this.state.errorMessageDoubleTickOrgId}
                            </Styled.Error>
                          )}
                        </Styled.Error>
                      )}
                    </Styled.InputField>
                  </Styled.LabelAndTextField>
                  <Styled.VerifyDetailsContainer>
                    Please verify details:
                    <Styled.DetailContainer>
                      <Styled.DetailTitle>Org Name</Styled.DetailTitle>
                      <Styled.Label>
                        {this.state.doubleTickOrgName}
                        {this.state.errorMessageDoubleTickOrgName && (
                          <Styled.Error>
                            {this.state.errorMessageDoubleTickOrgName}
                          </Styled.Error>
                        )}
                      </Styled.Label>
                    </Styled.DetailContainer>
                    <Styled.DetailContainer>
                      <Styled.DetailTitle>Owner Name</Styled.DetailTitle>
                      <Styled.Label>
                        {this.state.doubleTickOwnerName}
                      </Styled.Label>
                      {this.state.errorMessageDoubleTickOwnerName && (
                        <Styled.Error>
                          {this.state.errorMessageDoubleTickOwnerName}
                        </Styled.Error>
                      )}
                    </Styled.DetailContainer>
                  </Styled.VerifyDetailsContainer>
                  <Styled.LabelAndTextField>
                    <Styled.Label>Team Members</Styled.Label>
                    <Styled.InputField>
                      <TextField
                        disabled={this.state.disableTextField}
                        id="teamMembers"
                        type="number"
                        autoComplete="off"
                        className={classes.textField}
                        onKeyPress={this.onKeyPress}
                        value={this.state.doubleTickTeamMembers}
                        onChange={this.onDoubleTickTeamMembersChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                        margin="normal"
                      />
                      {this.state.errorDoubleTickTeamMembers && (
                        <Styled.Error>
                          Team Members is required when Doubletick is enabled
                        </Styled.Error>
                      )}
                    </Styled.InputField>
                  </Styled.LabelAndTextField>
                  <Styled.LabelAndTextField>
                    <Styled.Label>Doubletick Amount Paid</Styled.Label>
                    <Styled.InputField>
                      <TextField
                        disabled={this.state.disableTextField}
                        id="doubletickAmountPaid"
                        type="number"
                        autoComplete="off"
                        className={classes.textField}
                        onKeyPress={this.onKeyPress}
                        value={this.state.doubleTickAmountPaid}
                        onChange={this.onDoubleTickAmountChange}
                        InputProps={{
                          disableUnderline: true,
                          classes: { input: classes.input }
                        }}
                        margin="normal"
                      />
                      {this.state.errorMessageDoubleTickAmountPaid && (
                        <Styled.Error>
                          {this.state.errorMessageDoubleTickAmountPaid}
                        </Styled.Error>
                      )}
                    </Styled.InputField>
                  </Styled.LabelAndTextField>
                </Fragment>
              )}
              <Styled.LabelAndTextField>
                <Styled.Label>Plan Amount</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="planAmount"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    onKeyPress={this.onKeyPress}
                    value={this.state.originalAmount}
                    onChange={this.planAmountChange}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorPlanAmount && (
                    <Styled.Error>
                      Plan amount must be between 1 and 2,00,000
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Discount Type</Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    value={this.state.discountType}
                    onChange={this.onDiscountTypeChange}
                    className={classes.textField}
                  >
                    <MenuItem value="Discount %">Discount %</MenuItem>
                    <MenuItem value="Discount Amount">Discount Amount</MenuItem>
                  </Select>
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>{this.state.discountType}</Styled.Label>
                {this.state.discountType === 'Discount %' ? (
                  <Styled.InputField>
                    <TextField
                      disabled={this.state.disableDiscountField}
                      id="percentage"
                      type="number"
                      autoComplete="off"
                      onKeyPress={this.onKeyPress}
                      className={classes.textField}
                      value={this.state.discountPercent}
                      onChange={this.onDiscountPercentChange}
                      InputProps={{
                        disableUnderline: true,
                        classes: { input: classes.input }
                      }}
                      margin="normal"
                    />
                    {this.state.errorDiscountPercent && (
                      <Styled.Error>
                        Percentage must be between 1 and 100
                      </Styled.Error>
                    )}
                  </Styled.InputField>
                ) : (
                  <Styled.InputField>
                    <TextField
                      disabled={this.state.disableDiscountField}
                      id="amount"
                      type="number"
                      autoComplete="off"
                      value={this.state.discountAmount}
                      onChange={this.onDiscountAmountChange}
                      margin="normal"
                      className={classes.textField}
                      onKeyPress={this.onKeyPress}
                      InputProps={{
                        disableUnderline: true,
                        classes: { input: classes.input }
                      }}
                    />
                    {this.state.errorDiscountAmount && (
                      <Styled.Error>
                        {`Discount Amount must be between 0 and ${
                          this.state.strikedAmount
                            ? this.state.strikedAmount
                            : 'Plan Amount'
                        }`}
                      </Styled.Error>
                    )}
                  </Styled.InputField>
                )}
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Refund days</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Refund days"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.refundDays}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onRefundDaysChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorRefundDays && (
                    <Styled.Error>
                      Refund days must be between 1 and 14
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Final Amount</Styled.Label>
                <Styled.FinalPriceContainer>
                  <Styled.FinalAmount>
                    <Styled.FinalPrice>
                      {this.state.finalAmount || this.state.finalAmount === 0
                        ? `Rs.${this.state.finalAmount} `
                        : 'Final Amount'}
                    </Styled.FinalPrice>
                    <Styled.OriginalPrice>
                      {this.state.strikedAmount
                        ? `Rs. ${this.state.strikedAmount}`
                        : 'Original Amount'}
                    </Styled.OriginalPrice>
                  </Styled.FinalAmount>
                  <Styled.FinalPricePercentage>
                    {this.state.finalDiscountPercentage}% Discount
                  </Styled.FinalPricePercentage>
                </Styled.FinalPriceContainer>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.InputField>
                  <Button
                    tabIndex="-1"
                    type="submit"
                    classes={{ root: classes.button }}
                    onClick={this.onGenerateLink}
                  >
                    Generate Payment Link
                  </Button>
                  {this.state.errorGeneratedLink && (
                    <Styled.Error>
                      {this.state.errorMessage
                        ? this.state.errorMessage
                        : 'Something went wrong'}
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
            </FormControl>
          </Styled.GeneratePaymentLinkContainer>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(GeneratePaymentLink);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GeneratePaymentLink/index.js